import { useMemo } from 'react'

import { YStack } from '@zet/design-system/layout'
import { useBrandDetailsById } from '@zet/feature-brands/api/brands/hooks'
import { Benefits } from '@zet/feature-brands/components/benefits'
import useGetAgentDetailsAndTheme from '@zet/zet-pro-quick-journey/hooks/useGetAgentDetailsAndTheme'

import useVariantDetails from '../../hooks/useVariantDetails'

const BrandBenifitsContent = ({
  brandId,
  isFixedHeight,
  variantId,
}: {
  brandId: string | number
  isFixedHeight?: boolean
  variantId?: string | number
}) => {
  const { isJfsFlow } = useGetAgentDetailsAndTheme()
  const { data: content } = useBrandDetailsById(brandId)
  const { data: variantData } = useVariantDetails({
    variantId,
  })
  const removeIconsFromText = (text: string | undefined): string => {
    try {
      if (!text || typeof text !== 'string') return ''
      if (!isJfsFlow) return text
      // Remove emojis and common unicode icons (emoticons, symbols, etc.)
      return text
        .replace(
          /[\u{1F300}-\u{1F9FF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}]|[\u{1F600}-\u{1F64F}]|[\u{1F680}-\u{1F6FF}]|[\u{1F1E0}-\u{1F1FF}]|[\u{1F900}-\u{1F9FF}]|[\u{1FA00}-\u{1FA6F}]|[\u{1FA70}-\u{1FAFF}]|[\u{2190}-\u{21FF}]|[\u{2300}-\u{23FF}]|[\u{2B50}-\u{2B55}]/gu,
          '',
        )
        .trim()
    } catch (error) {
      // Fallback to original text if regex fails
      console.warn('Error removing icons from text:', error)
      return typeof text === 'string' ? text : ''
    }
  }

  const benefits = useMemo(
    () =>
      (variantData?.detailedBenefits || content?.brandBenefits)?.map(
        (element: any, index: number) => {
          try {
            return {
              id: index,
              icon: '',
              heading: removeIconsFromText(element?.heading),
              content: element?.subText || [],
            }
          } catch (error) {
            console.warn('Error processing benefit element:', error)
            return {
              id: index,
              icon: '',
              heading: element?.heading || '',
              content: element?.subText || [],
            }
          }
        },
      ) || [],
    [content, variantData?.detailedBenefits, isJfsFlow],
  )
  return (
    <YStack
      style={
        isFixedHeight
          ? {
              marginBottom: 40,
              ...(isJfsFlow ? { backgroundColor: 'white' } : {}),
            }
          : { ...(isJfsFlow ? { backgroundColor: 'white' } : {}) }
      }
    >
      {benefits?.map((benefit, index) => (
        <Benefits {...benefit} key={index} />
      ))}
    </YStack>
  )
}

export default BrandBenifitsContent
